import { render, staticRenderFns } from "./RetailerList.vue?vue&type=template&id=4edd828c&scoped=true&"
import script from "./RetailerList.vue?vue&type=script&lang=js&"
export * from "./RetailerList.vue?vue&type=script&lang=js&"
import style0 from "./RetailerList.vue?vue&type=style&index=0&id=4edd828c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4edd828c",
  null
  
)

export default component.exports